import createIcon from '../../createIcon';

/**
 * @component @name Sort
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxOEg5VjE2SDNWMThaTTMgNlY4SDIxVjZIM1pNMyAxM0gxNVYxMUgzVjEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Sort = createIcon('Sort', [
  ['path', { d: 'M3 18H9V16H3V18ZM3 6V8H21V6H3ZM3 13H15V11H3V13Z', key: '7cg84y' }],
]);

export default Sort;
